import { FeaturesIncluded } from "@ecologi/react-components/src/FeaturesIncluded";

export default FeaturesIncluded;
